import React from "react";
import styled from "styled-components";
import {theme} from "../theme/theme"

const FooterBlock = styled.footer`  
    width: 100%;
    height: 8rem;
    background: ${theme.colors.text};
`

const Footer = ()=>(
    <FooterBlock>

    </FooterBlock>
)
export default Footer